export default {
    init() {
        // ROLE PRICING PLUGIN GLITCH FIX
        // YITH Role Based Prices renders both the regular and the "your price"
        // value; hide the duplicate when they are identical.
        $('span.price').each(function () {
            const regular = $(this).find('span.ywcrbp_regular_price');
            const your = $(this).find('span.ywcrbp_your_price');
            const regularText = regular.find('span.woocommerce-Price-amount bdi').text();
            const yourText = your.find('span.woocommerce-Price-amount bdi').text();

            if (regularText === yourText) {
                your.hide();
            }
        });
    },
}



// WEBPACK FOOTER //
// ./scripts/routes/shop.js